import {CardItem} from '@domain/last-modified-card-object/card-item';
import {TexfabCardItem} from '@domain/last-modified-card-object/texfab-card-item';
import {isNil} from 'lodash-es';

export class TexfabSalesLastModified {
  private readonly _article: CardItem;
  private readonly _customer: CardItem;
  private readonly _salesOrder: CardItem;

  public constructor(article: CardItem, customer: CardItem, salesOrder: CardItem) {
    this._article = article;
    this._customer = customer;
    this._salesOrder = salesOrder;
  }

  public get article(): CardItem {
    return this._article;
  }

  public get customer(): CardItem {
    return this._customer;
  }

  public get salesOrder(): CardItem {
    return this._salesOrder;
  }

  public static fromJSON(lastModifiedJSON: any): TexfabSalesLastModified {
    return new TexfabSalesLastModified(
      new CardItem(
        !isNil(lastModifiedJSON?.article?.lastModified) ? new TexfabCardItem(lastModifiedJSON.article.lastModified.id, lastModifiedJSON.article.lastModified.name) : null,
        lastModifiedJSON?.article?.totalCreated
      ),
      new CardItem(
        !isNil(lastModifiedJSON?.customer?.lastModified) ? new TexfabCardItem(lastModifiedJSON.customer.lastModified.id, lastModifiedJSON.customer.lastModified.name) : null,
        lastModifiedJSON?.customer?.totalCreated
      ),
      new CardItem(
        !isNil(lastModifiedJSON?.salesOrder?.lastModified) ? new TexfabCardItem(lastModifiedJSON.salesOrder.lastModified.id, lastModifiedJSON.salesOrder.lastModified.name) : null,
        lastModifiedJSON?.salesOrder?.totalCreated
      )
    );
  }
}
